import { CardTextDto } from "@dtos/card-text.dto";
import { CardTextModel } from "@models/card-text.model";
import { BaseService } from "./base.service";
import gateway from "@interceptors/gateway.interceptor";

class CardTextService extends BaseService {
    public deleteCardText = async (id: number) => {
        const url = `/card-text/delete/${id}`
        const response = await gateway.delete(url)
        return response.data
    }
    public createCardText = async (idAccomodation: string, cardTextModel: CardTextModel, formData: FormData) => {
        const url = `/card-text/save`;
        const dto = this.cardTextConverter.modelToDto(cardTextModel);
        const bodyJsonString = JSON.stringify(dto);
        formData.append('body', new Blob([bodyJsonString], { type: 'application/json' }));
        const response = await gateway.post(url, formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            },
            params: {
                "idAccomodation": idAccomodation
            }
        });
        return response.data;
    }

    public findCardText = async (idCardText: string) => {
        const url = `/card-text/find-by-card-text-id/${idCardText}`;
        const response = await gateway.get(url);
        return response.data;
    }

    public updateCardText = async (idcardText: string, idAccomodation: string, model: CardTextModel, formData: FormData) => {
        const url = `/card-text/update/${idcardText}`;
        const dto = this.cardTextConverter.modelToDto(model);
        const bodyJsonString = JSON.stringify(dto);
        formData.append('body', new Blob([bodyJsonString], { type: 'application/json' }));
        const response = await gateway.put(url, formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            },
            params: {
                "idAccomodation": idAccomodation
            }
        });
        return response.data;

    }
}

export default new CardTextService();